import { render, staticRenderFns } from "./TariffBuy.vue?vue&type=template&id=cec464e2&scoped=true"
import script from "./TariffBuy.vue?vue&type=script&lang=js"
export * from "./TariffBuy.vue?vue&type=script&lang=js"
import style0 from "./TariffBuy.vue?vue&type=style&index=0&id=cec464e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec464e2",
  null
  
)

export default component.exports